import {
  GET_NEWS_ITEMS,
  GET_NEWS_ITEMS_SUCCESS,
  GET_NEWS_ITEMS_ERROR,
  UPDATE_NEWS_ITEM,
  UPDATE_NEWS_ITEM_SUCCESS,
  UPDATE_NEWS_ITEM_ERROR,
  UPDATE_NEWS_FEED,
  ADD_COMMENT_ITEM,
  ADD_COMMENT_SUCCESS,
  ADD_COMMENT_ERROR,
  GET_COMMENTS,
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_ERROR,
  GET_LIKED_POSTS_BY_CURRENT_USER,
  GET_LIKED_POSTS_BY_CURRENT_USER_SUCCESS,
  GET_LIKED_POSTS_BY_CURRENT_USER_ERROR,
  GET_POST_LIKES,
  GET_POST_LIKES_SUCCESS,
  GET_POST_LIKES_ERROR,
  GET_NEWS_ITEM,
  GET_NEWS_ITEM_SUCCESS,
  GET_NEWS_ITEM_ERROR,  
} from '../actions';

export const getComments = (postId) => ({
  type: GET_COMMENTS,
  payload: { postId }
});

export const getCommentsSuccess = (list) => ({
  type: GET_COMMENTS_SUCCESS,
  payload: {list}
});

export const getCommentsError = (message) => ({
  type: GET_COMMENTS_ERROR,
  payload: { message }
});

export const getNewsItems = (pageNumber, activityInfo) => ({
  type: GET_NEWS_ITEMS,
  payload: { pageNumber, activityInfo }
});

export const getNewsItemsSuccess = (newsItems) => ({
  type: GET_NEWS_ITEMS_SUCCESS,
  payload: {newsItems}
});

export const getNewsItemsError = (message) => ({
  type: GET_NEWS_ITEMS_ERROR,
  payload: { message }
});

export const getNewsItem = (articleId) => ({
  type: GET_NEWS_ITEM,
  payload: { articleId }
});

export const getNewsItemSuccess = (newsItem) => ({
  type: GET_NEWS_ITEM_SUCCESS,
  payload: {newsItem}
});

export const getNewsItemError = (message) => ({
  type: GET_NEWS_ITEM_ERROR,
  payload: { message }
});

export const addComment = (newsItem, comment, contactId) => ({
  type: ADD_COMMENT_ITEM,
  payload: { newsItem, comment, contactId }
});

export const addCommentSuccess = (updatedNewsItem) => ({
  type: ADD_COMMENT_SUCCESS,
  payload: {updatedNewsItem}
});

export const addCommentError = (message) => ({
  type: ADD_COMMENT_ERROR,
  payload: { message }
});

export const updateNewsItem = (newsItem, isLiked, contactId, isDelete) => ({
  type: UPDATE_NEWS_ITEM,
  payload: { newsItem, isLiked, contactId, isDelete }
});

export const updateNewsItemSuccess = (updatedNewsItem) => ({
  type: UPDATE_NEWS_ITEM_SUCCESS,
  payload: {updatedNewsItem}
});

export const updateNewsItemError = (message) => ({
  type: UPDATE_NEWS_ITEM_ERROR,
  payload: { message }
});

export const getLikedPostsByCurrentUser = (contactId) => ({
  type: GET_LIKED_POSTS_BY_CURRENT_USER,
  payload: { contactId }
});

export const getLikedPostsByCurrentUserSuccess = (likedPostIds) => ({
  type: GET_LIKED_POSTS_BY_CURRENT_USER_SUCCESS,
  payload: {likedPostIds}
});

export const getLikedPostsByCurrentUserError = (message) => ({
  type: GET_LIKED_POSTS_BY_CURRENT_USER_ERROR,
  payload: { message }
});

export const getPostLikes = (postId) => ({
  type: GET_POST_LIKES,
  payload: { postId }
});

export const getPostLikesSuccess = (postId, likeCount) => ({
  type: GET_POST_LIKES_SUCCESS,
  payload: {postId, likeCount}
});

export const getPostLikesError = (message) => ({
  type: GET_POST_LIKES_ERROR,
  payload: { message }
});

export const updateNewsFeed = (updatedValues) => ({
  type: UPDATE_NEWS_FEED,
  payload: { updatedValues }
});